import api from './client';
export async function linkSlackAccount(token: string) {
  const { data } = await api.post('/slack/link-account', {
    slackToken: token,
  });

  return data;
}
